export default {
  List: "/tcs/link-management",
};
